export function listIncludes(includes: string[], object: string[]) {
  if (includes.length == 0) {
    return true;
  }
  for (const x of includes) {
    if (object.includes(x)) {
      return true;
    }
  }
  return false;
}

export function listRequires(requires: string[], object: string[]) {
  if (requires.length == 0) {
    return true;
  }

  for (const x of requires) {
    if (!object.includes(x)) {
      return false;
    }
  }
  return true;
}

export function listExcludes(
  includes: string[],
  excludes: string[],
  object: string[]
) {
  if (excludes.length == 0) {
    return true;
  }

  for (const x of excludes) {
    if (includes.includes(x)) {
      continue;
    }
    if (object.includes(x)) {
      return false;
    }
  }

  return true;
}
